import { render, staticRenderFns } from "./ContactsModal.vue?vue&type=template&id=026cf2e9&scoped=true"
import script from "./ContactsModal.vue?vue&type=script&lang=js"
export * from "./ContactsModal.vue?vue&type=script&lang=js"
import style0 from "./ContactsModal.vue?vue&type=style&index=0&id=026cf2e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026cf2e9",
  null
  
)

export default component.exports